/**
 * SONUCU BİLİNMEYEN YAZMA (T4 QA P2-1, T5'te ortak pakete taşındı).
 *
 * Yanıt hiç gelmedi (ağ, zaman aşımı, iptal → `statusCode` 0), 408 ya da
 * sunucu 5xx döndü: istek sunucuda işlenmiş OLABİLİR. Ekran "kaydedilmedi" /
 * "gönderilemedi" gibi kesin bir cümle KURAMAZ, ilgili veriyi yeniden çeker.
 * 4xx kesin rettir: sunucu işi yapmadığını söylemiştir.
 *
 * Panel (satış adayı, kurum açma, kredi) ve web (yayın onayı, satış formu)
 * AYNI kuralı okur; kural iki uygulamada ayrı ayrı yazılırsa biri bayatlar.
 */
export function isOutcomeUnknown(error) {
    if (!error)
        return false;
    return error.statusCode === 0 || error.statusCode === 408 || error.statusCode >= 500;
}
//# sourceMappingURL=write-outcome.js.map